enum ClaimsActivityLineOfBusinessTypeEnum {
  Total = "Total",
  Medicare = "Medicare",
  Medicaid = "Medicaid",
  Commercial = "Commercial",  
  VA = "VA",
  TRICARE = "TRICARE"
}

export { ClaimsActivityLineOfBusinessTypeEnum };
